import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            按主题浏览51吃瓜黑料网的全部精彩内容，找瓜更方便
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl p-5 border border-background-200/70 group cursor-pointer hover:border-primary-200 transition-colors text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-sm font-heading text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium">
                <i className="ri-file-text-line"></i>
                {item.count}篇内容
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}